import './Logout.css';
import '../common-style.css';

import { serverLogout } from '../../connector/auth';
import { OrRuler } from 't-lib-ui/structure';
import { useContext, useState } from 'react';
import { AppState } from '../../context/general';
import { goTo, RouterContext } from 't-lib-ui/router';
import { FlowForm, useFlowFormGlobal, FormGrid, FormGridLine } from 't-lib-ui/structure';
import { TextButton } from 't-lib-ui/widgets';
import DownreadLogo from '../../components/DownreadLogo';
import { LoggedOutScreen } from './LoggedOut';

const Logout: React.FC = () => {
  const routerCtx = useContext(RouterContext);
  const appState = useContext(AppState);
  useFlowFormGlobal();

  // After logging out we stay on this page and show a confirmation screen (/logout is an unauth page,
  // so it keeps rendering once logged out); only the explicit button below leaves for the start screen.
  const [done, setDone] = useState(false);

  function logoutClicked() {
    serverLogout();
    appState.setLoggedOut();
    setDone(true);
  }

  function reloginClicked() {
    serverLogout();
    appState.setLoggedOut();
    goTo(routerCtx, '/login', 'replace');
  }

  if (done)
    return <LoggedOutScreen message="You've been logged out." />;

  return (
    <FlowForm main={true}>
      <div className="authPage">
        <div className="authCard logoutCard">
          <div className="authLogo">
            <a href="https://downread.com" className="authLogoLink"><DownreadLogo size={48} showText /></a>
          </div>
          <div className="authIntro">Log out or switch to a different account.</div>

          <FormGrid>
            <FormGridLine span={2} align='center' className='logoutActionRow'>
              <TextButton label='Log out' onClick={logoutClicked} className='logOut' type='major'/>
            </FormGridLine>
          </FormGrid>

          <div className="authDivider"><OrRuler /></div>

          <FormGrid>
            <FormGridLine span={2} align='center' className='logoutActionRow'>
              <TextButton label='Log into a different account' type='minor' onClick={reloginClicked} className='relogin' />
            </FormGridLine>
          </FormGrid>
        </div>
      </div>
    </FlowForm>
  );
};

export default Logout;
